<template>
    <inertia-head title="Register"/>

    <jet-authentication-card>
        <template #logo>
            <div class="h-32 md:h-auto md:w-1/2">
                <jet-authentication-card-logo/>
            </div>
        </template>

        <div class="w-full">
            <jet-validation-errors class="mb-4"/>

            <h1
                class="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-400"
            >
                Create account
            </h1>
            <form @submit.prevent="submit">
                <label class="block text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Name</span>
                    <jet-input
                        type="text"
                        name="name"
                        class="block w-full"
                        placeholder="John Doe"
                        v-model="form.name"
                        required
                        autofocus
                        autocomplete="name"
                    />
                </label>
                <label class="block mt-4 text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Email</span>
                    <jet-input
                        type="email"
                        name="email"
                        class="block w-full"
                        placeholder="email@example.com"
                        v-model="form.email"
                        required
                        autocomplete="email"
                    />
                </label>
                <label class="block mt-4 text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Password</span>
                    <jet-input
                        type="password"
                        name="password"
                        class="block w-full"
                        placeholder="***************"
                        v-model="form.password"
                        required
                        autocomplete="new-password"
                    />
                </label>
                <label class="block mt-4 text-sm">
                    <span class="text-gray-700 dark:text-gray-400">
                      Confirm password
                    </span>
                    <jet-input
                        type="password"
                        name="password_confirmation"
                        class="block w-full"
                        placeholder="***************"
                        v-model="form.password_confirmation"
                        required
                        autocomplete="new-password"
                    />
                </label>
                <label class="block mt-4 text-sm">
                    <span class="text-gray-700 dark:text-gray-400">Organization</span>
                    <jet-input
                        type="text"
                        name="organization[name]"
                        class="block w-full"
                        placeholder="My Organization"
                        v-model="form.organization.name"
                        required
                        autofocus
                        autocomplete="name"
                    />
                </label>

                <div class="flex mt-6 text-sm" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
                    <label class="flex items-center dark:text-gray-400">
                        <jet-checkbox name="terms" id="terms" v-model:checked="form.terms"/>
                        <span class="ml-2">
                            I agree to the <a target="_blank" :href="route('terms.show')" ref="noopener"
                                              class="underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">Terms of Service</a> and <a
                            target="_blank" :href="route('policy.show')" ref="noopener"
                            class="underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200">Privacy Policy</a>
                        </span>
                    </label>
                </div>

                <!-- You should use a button here, as the anchor is only used for the example  -->
                <jet-button class="block w-full mt-4">
                    Create account
                </jet-button>

                <div class="fixed bottom-4 right-4">
                    <google-re-captcha-v3
                        v-model="form.gRecaptchaResponse"
                        ref="captcha"
                        :site-key="$page.props.google_recaptcha_site_key"
                        id="register_recaptcha"
                        inline
                        action="register"
                    ></google-re-captcha-v3>
                </div>

                <hr class="my-8"/>

                <p class="mt-4">
                    <a
                        class="text-sm font-medium text-purple-600 dark:text-purple-400 hover:underline"
                        :href="route('login')"
                    >
                        Already have an account? Login
                    </a>
                </p>

            </form>
        </div>
    </jet-authentication-card>
</template>

<script>
import {defineComponent} from 'vue'
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
import GoogleReCaptchaV3 from "@/Components/googlerecaptchav3/GoogleReCaptchaV3";

export default defineComponent({
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        GoogleReCaptchaV3
    },

    data() {
        return {
            test: null,
            form: this.$inertia.form({
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                organization: {
                    name: '',
                },
                terms: false,
                gRecaptchaResponse: null,
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('register'), {
                onFinish: () => {
                    this.form.reset('password', 'password_confirmation');
                    this.$refs.captcha.execute();
                }
            })
        }
    }
})
</script>
